const { pix, regexes } = require('@transfeeradev/api-enums');
const PersonTypeService = require('./PersonTypeService');
const { validate: validateUUID } = require('uuid');

class PixKeyValidationService {
  static isValidKeyType(keyType) {
    if (!Object.values(pix.keyType).includes(keyType)) {
      return false;
    }

    return true;
  }

  static isValid(keyType, keyValue) {
    if (!PixKeyValidationService.isValidKeyType(keyType) || typeof keyValue !== 'string') {
      return false;
    }

    if (keyType === pix.keyType.CPF) {
      return PersonTypeService.isCPF(keyValue) && PersonTypeService.isValidCPF(keyValue);
    } else if (keyType === pix.keyType.CNPJ) {
      return PersonTypeService.isCNPJ(keyValue) && PersonTypeService.isValidCNPJ(keyValue);
    } else if (keyType === pix.keyType.EMAIL) {
      return regexes.EMAIL.test(keyValue);
    } else if (keyType === pix.keyType.TELEFONE) {
      return regexes.MOBILE_PHONE.test(keyValue);
    } else if (keyType === pix.keyType.CHAVE_ALEATORIA) {
      return validateUUID(keyValue);
    }

    return false;
  }

  static identifyPixKeyType(key) {
    if (key.trim().startsWith('+') && regexes.MOBILE_PHONE.test(key)) {
      return pix.keyType.TELEFONE;
    } else if (validateUUID(key)) {
      return pix.keyType.CHAVE_ALEATORIA;
    } else if (PersonTypeService.isCPF(key) && PersonTypeService.isValidCPF(key)) {
      return pix.keyType.CPF;
    } else if (PersonTypeService.isCNPJ(key) && PersonTypeService.isValidCNPJ(key)) {
      return pix.keyType.CNPJ;
    } else if (regexes.EMAIL.test(key)) {
      return pix.keyType.EMAIL;
    }

    throw new Error('Could not identify pix key');
  }
}

module.exports = PixKeyValidationService;
